export enum CustomLinksIcons {
  globe = 'globe',
  document = 'document',
  bookmark = 'bookmark',
  picture = 'picture',
  cup = 'cup',
  briefcase = 'briefcase',
  advertising = 'advertising',
  user = 'user',
  employee = 'employee',
  star = 'star',
  flash = 'flash',
  hearts = 'hearts',
  info = 'info',
  notebook = 'notebook',
  video = 'video',
  employeeInfo = 'employee_info',
  card = 'card',
  hat = 'hat',
  lightbulb = 'lightbulb',
  thermometer = 'thermometer',
  chain = 'chain',
  phone = 'phone',
  book = 'book',
  building = 'building',
  grid = 'grid',
}
